import { Box } from "@mui/system";
import { ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        justifyContent: "center",
        width: "100%",
        minHeight: 0,
      }}
    >
      {children}
    </Box>
  );
}
